export default __webpack_public_path__ + "static/media/screen4.c23cb258.png";